function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useState } from "react";
import CheckIcon from "../../Icon/Check";
import ArrangeIcon from "../../Icon/Arrange";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useStyle } from "./Tile.styles";
export default function Tile(_param) {
    var children = _param.children, clickable = _param.clickable, draggable = _param.draggable, hasError = _param.hasError, _height = _param.height, height = _height === void 0 ? '100%' : _height, isDisabled = _param.isDisabled, isRtl = _param.isRtl, isSelectedProp = _param.isSelected, onClick = _param.onClick, padding = _param.padding, selectable = _param.selectable, _selectedIndicatorPlacement = _param.selectedIndicatorPlacement, selectedIndicatorPlacement = _selectedIndicatorPlacement === void 0 ? 'top-end' : _selectedIndicatorPlacement, testID = _param.testID, _width = _param.width, width = _width === void 0 ? '100%' : _width, _selectedIndicator = _param.selectedIndicator, selectedIndicator = _selectedIndicator === void 0 ? true : _selectedIndicator, selectedIndicatorOffset = _param.selectedIndicatorOffset, propDrop = _objectWithoutProperties(_param, [
        "children",
        "clickable",
        "draggable",
        "hasError",
        "height",
        "isDisabled",
        "isRtl",
        "isSelected",
        "onClick",
        "padding",
        "selectable",
        "selectedIndicatorPlacement",
        "testID",
        "width",
        "selectedIndicator",
        "selectedIndicatorOffset"
    ]);
    var ref = _slicedToArray(useState(false), 2), selected1 = ref[0], setSelected = ref[1];
    var isExternallyControlled = isSelectedProp !== undefined;
    var isSelected = isExternallyControlled ? isSelectedProp : selected1;
    var isInteractive = clickable || selectable;
    var ref1 = useStyle({
        width: width,
        height: height,
        isDisabled: isDisabled,
        isRtl: isRtl,
        hasError: hasError,
        padding: padding,
        selectedIndicatorPlacement: selectedIndicatorPlacement,
        selected: selectable && isSelected,
        clickable: clickable,
        selectable: isInteractive,
        selectedIndicatorOffset: selectedIndicatorOffset
    }), container = ref1.container, iconWrapper = ref1.iconWrapper, content = ref1.content, selectedIcon = ref1.selectedIcon;
    var handleInteraction = function(event) {
        event.preventDefault();
        if (isDisabled) return;
        if (clickable && onClick !== undefined) {
            onClick(event);
        }
        if (selectable && !isExternallyControlled) {
            setSelected(function(selected) {
                return !selected;
            });
        }
    };
    var handleOnKeydown = function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            handleInteraction(event);
        }
    };
    var handleOnDrag = function(event) {
        event.stopPropagation();
    };
    return _jsxs("div", _objectSpread({
        css: container,
        onClick: handleInteraction,
        onKeyDown: handleOnKeydown,
        tabIndex: isInteractive && !isDisabled ? 0 : -1,
        "aria-selected": selectable && isSelected
    }, propDrop, injectTestId(testID), {
        className: propDrop.className ? "focus-visible ".concat(propDrop.className) : 'focus-visible',
        children: [
            draggable && !isDisabled && _jsx("div", {
                css: iconWrapper,
                onClick: handleOnDrag,
                children: _jsx(ArrangeIcon, {})
            }),
            selectable && selectedIndicator && isSelected && _jsx("div", {
                css: selectedIcon,
                id: testID && "".concat(testID, "-check-icon"),
                children: _jsx(CheckIcon, {
                    size: "m"
                })
            }),
            _jsx("div", {
                css: content,
                children: children
            })
        ]
    }));
};
